import { render, staticRenderFns } from "./ProductCollectionsNew.vue?vue&type=template&id=3171030c&scoped=true&"
import script from "./ProductCollectionsNew.vue?vue&type=script&lang=js&"
export * from "./ProductCollectionsNew.vue?vue&type=script&lang=js&"
import style0 from "./ProductCollectionsNew.vue?vue&type=style&index=0&id=3171030c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3171030c",
  null
  
)

export default component.exports